// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class QuoteConfigSummaryPlant {
  readonly plantId: string;
  readonly plantName: string;
  readonly marketId: string;
  readonly marketName: string;
  readonly plantIsArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.marketName = data.marketName === undefined ? '' : data.marketName;
    this.plantIsArchived = data.plantIsArchived === undefined ? false : data.plantIsArchived;
  }

  static zero(): QuoteConfigSummaryPlant {
    const zeroValues: ExcludeMethodsDeep<QuoteConfigSummaryPlant> = {
      plantId: NIL_UUID,
      plantName: '',
      marketId: NIL_UUID,
      marketName: '',
      plantIsArchived: false,
    };
    return new QuoteConfigSummaryPlant(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteConfigSummaryPlantWireFormat = {
  plantId: string;
  plantName: string;
  marketId: string;
  marketName: string;
  plantIsArchived: boolean;
};

type NewQuoteConfigSummaryPlantProps = PartialDeep<
  QuoteConfigSummaryPlant,
  { recurseIntoArrays: true }
>;
export const NewQuoteConfigSummaryPlant: (
  props: NewQuoteConfigSummaryPlantProps,
) => QuoteConfigSummaryPlant = (props) => new QuoteConfigSummaryPlant(props);

type NewQuoteConfigSummaryPlantFromWireFormatProps = PartialDeep<
  QuoteConfigSummaryPlantWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteConfigSummaryPlantFromWireFormat: (
  props: NewQuoteConfigSummaryPlantFromWireFormatProps,
) => QuoteConfigSummaryPlant = (props) => new QuoteConfigSummaryPlant(props);
